const locale = navigator.language;
const timeZone = 'UTC';

const monthFormatter = new Intl.DateTimeFormat(locale, {
  timeZone,
  month: 'long',
  year: 'numeric',
});

const defaultFormatter = new Intl.DateTimeFormat(locale, {timeZone});

const quarters = [
  'First Quarter',
  'Second Quarter',
  'Third Quarter',
  'Fourth Quarter',
];

export const types = {
  TIMELAPSE: 'timelapse',
  BASEMAP: 'basemap',
};

export const intervals = {
  MONTH: '1 mon',
  QUARTER: '3 mons',
  WEEK: '7 days',
  DAY: '1 day',
  NONE: undefined,
};

export const MOSAIC_TYPES = {
  [intervals.QUARTER]: 'Quarterly',
  [intervals.MONTH]: 'Monthly',
  [intervals.WEEK]: 'Weekly',
  [intervals.DAY]: 'Daily',
  [intervals.NONE]: 'Basemap',
};

export function getTimeInfo(mosaic) {
  let info;
  const startDate = new Date(mosaic.first_acquired);
  const endDate = new Date(mosaic.last_acquired);
  if (mosaic.product_type === types.TIMELAPSE) {
    switch (mosaic.interval) {
      case intervals.MONTH: {
        info = monthFormatter.format(startDate);
        break;
      }
      case intervals.QUARTER: {
        const quarter = Math.floor(startDate.getUTCMonth() / 3);
        info = `${quarters[quarter]} ${startDate.getUTCFullYear()}`;
        break;
      }
      default: {
        // pass
      }
    }
  }
  if (!info) {
    info = `${defaultFormatter.format(startDate)}–${defaultFormatter.format(
      endDate
    )}`;
  }
  return info;
}

export function isGlobal(mosaic) {
  const bbox = mosaic.bbox;
  return bbox[0] === -180 && bbox[2] === 180 && bbox[1] < -55 && bbox[3] > 55;
}

export function byRecency(mosaic0, mosaic1) {
  if (
    mosaic0.product_type === types.TIMELAPSE &&
    mosaic1.product_type !== types.TIMELAPSE
  ) {
    return -1;
  }
  if (
    mosaic1.product_type === types.TIMELAPSE &&
    mosaic0.product_type !== types.TIMELAPSE
  ) {
    return 1;
  }
  const last0 = Date.parse(mosaic0.last_acquired);
  const last1 = Date.parse(mosaic1.last_acquired);
  if (last0 > last1) {
    return -1;
  }
  if (last0 < last1) {
    return 1;
  }
  const first0 = Date.parse(mosaic0.first_acquired);
  const first1 = Date.parse(mosaic1.first_acquired);
  return first0 - first1 || mosaic0.name.length - mosaic1.name.length;
}
